import React from "react";

function ThemeSwitcher(props) {

    function handleThemeChange(theme) {
        if (props?.updateThemeCallback) {
            props.updateThemeCallback(theme);
        }
    }

    return (
        <div className={'nav-item dropdown bg-' + props.theme} data-bs-theme={props.theme}>
            <button
                className='nav-link dropdown-toggle'
                type='button'
                id='navbarDropdown'
                data-bs-toggle='dropdown'
                aria-expanded='false'
                // role="button"
            >
                Change Theme
            </button>
            <div className='dropdown-menu' id="navbarDropdown" aria-labelledby="navbarDropdown">
                <div className='dropdown-item' onClick={() => handleThemeChange('light')}>Light Theme</div>
                <div className='dropdown-item' onClick={() => handleThemeChange('dark')}>dark Theme</div>
            </div>
        </div>
    );
}

export default ThemeSwitcher;